import React, { FC, memo, useState } from 'react'
import ModalWrapper from '../../../components/Modal/ModalWrapper'
import Button from '../../../components/Button'
import CrossIcon from '../../../icons/cross.svg'

interface IOwnProps {
  onRequest: () => void
  onClose: () => void
}

const OrderRequest: FC<IOwnProps> = ({ onRequest, onClose }) => (
  <ModalWrapper
    className="import order-request-modal"
    testId="order-request-modal"
    labelledBy="order-request-modal-title"
  >
    <button
      className="import_backdrop clear-button"
      onClick={onClose}
      data-testid="order-request-modal-backdrop"
    />
    <div className="import_dialog action-modal">
      <div className="action-modal_title" id="order-request-modal-title">
        Request approval Order
      </div>
      <CrossIcon
        className="product-modal_close"
        onClick={onClose}
        data-testid="order-request-modal-close"
      />
      <div className="action-modal_info">
        Are you sure you want to request approval for this order?
      </div>
      <div className="action-modal_actions">
        <Button
          block
          color="success"
          onClick={onRequest}
          data-testid="order-request-submit"
        >
          Request approval
        </Button>
        <Button
          block
          color="primary-link"
          className="action-modal_cancel"
          onClick={onClose}
          data-testid="order-request-cancel"
        >
          Continue Editing
        </Button>
      </div>
    </div>
  </ModalWrapper>
)

export default memo(OrderRequest)

export const useOrderRequestModal = ({
  onRequest,
}: {
  onRequest: () => void
}): [{ open: () => void; close: () => void }, any] => {
  const [opened, setOpened] = useState<boolean>(false)
  const open = () => setOpened(true)
  const close = () => setOpened(false)
  const modal = <OrderRequest onRequest={onRequest} onClose={close} />
  return [{ open, close }, opened ? modal : null]
}
